var borders_default = {
  "borderT": "TL0LJ",
  "borderB": "DiYJb",
  "borderL": "aGqqV",
  "borderR": "YRGCK",
  "borderColorOverride": "dFDae"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
